import PropTypes from 'prop-types';

export default function Skeleton({ variant = 'text', className = '', style = {}, width, height }) {
  const base = 'skeleton';
  const shape = variant === 'circle' ? 'skeleton--circle' : variant === 'rect' ? 'skeleton--rect' : 'skeleton--text';
  const wStyle = width != null ? { width: typeof width === 'number' ? `${width}px` : width } : {};
  const hStyle = height != null ? { height: typeof height === 'number' ? `${height}px` : height } : {};
  return (
    <div className={[base, shape, className].filter(Boolean).join(' ')} style={{ ...wStyle, ...hStyle, ...style }} />
  );
}

Skeleton.propTypes = {
  variant: PropTypes.oneOf(['text', 'rect', 'circle']),
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};